import { render, staticRenderFns } from "./liveclass.vue?vue&type=template&id=e3ad5e0a&scoped=true&"
import script from "./liveclass.vue?vue&type=script&lang=js&"
export * from "./liveclass.vue?vue&type=script&lang=js&"
import style0 from "./liveclass.vue?vue&type=style&index=0&id=e3ad5e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ad5e0a",
  null
  
)

export default component.exports